import { useEffect } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import { getFaqLink } from "@hsbc/utilities";

export const FaqPage = () => {
  const { language } = useI18nContext();

  useEffect(() => {
    window.location.href = getFaqLink(language);
  }, [language]);

  return null;
};
